/**
 * Generated by orval v6.20.0 🍺
 * Do not edit manually.
 * portrich-api
 * OpenAPI spec version: 0.0.0
 */

/**
 * * `PER_ITEM` - 各費目単位で丸める
* `PER_TOTAL` - 合計金額で丸める
 */
export type TotalAmountCalculationTypeEnum = typeof TotalAmountCalculationTypeEnum[keyof typeof TotalAmountCalculationTypeEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TotalAmountCalculationTypeEnum = {
  PER_ITEM: 'PER_ITEM',
  PER_TOTAL: 'PER_TOTAL',
} as const;
